import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import {
  sendRequest,
  changeDefaultQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

import TasksToExecutorsList from 'components/Tasks/TasksToExecutorsList';

class TasksToExecutors extends Component {
  componentWillMount() {
    this.props.changeDefaultQueryParams({
      page: 1,
      sort: '-created_at',
      hide_from_black_list: '1'
    });
    this.props.sendRequest();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return <TasksToExecutorsList reducerName={this.props.listReduceName} />;
  }
}

TasksToExecutors.propTypes = {
  // IN
  listReduceName: PropTypes.string.isRequired,

  // CONNECT
  changeDefaultQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch, props) => ({
  changeDefaultQueryParams: queryParams =>
    dispatch(changeDefaultQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default withRouter(
  connect(
    () => ({}),
    mapDispatchToProps
  )(TasksToExecutors)
);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/TasksToExecutors/TasksToExecutors.js